export const microElectricBikePlateNumberFormatStrategy = (value: string) =>
  !!value.match('^[A-Z]{2}[0-9]{5}$');
